import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { getMetadataCategories, getDataById, getMetadata, handleUrl } from './utils';
import uniqid from "uniqid";

import { useHistory, useLocation, useRouteMatch } from 'react-router';
import { Button } from '../stories/Button';
import { UIbutton } from '../uikit/Uikit';
import { HIGHTLIGHTS_ID } from '../config';
import { UItoggle } from '../uikit/UItoggle';
import { MetadataFilters } from './MetadataFilters';
import { MetadataThreads } from './MetadataThreads';
import { MetadataSearch } from './MetadataSearch';


export function ContentInfo({ videoId, handleClick = () => void (0) }) {


  return (
    <>
      <div className="l_content_metadata_info">
        <div className="l_content_metadata_sticky">

          <MetadataSearch videoId={videoId} />

          <MetadataThreads videoId={videoId} />

          <MetadataFilters videoId={videoId} />

        </div>
      </div>

    </>
  )
}


export function ContentInfoLine({ typeRef, videoId, key, handleClick, view = 'summary' }) {



  const context = useContext(Context);
  const info = getDataById(context, 'metaDataTypes', typeRef);

  return (
    <div className="l_info_sum0" key={key}>
      <div className="l_info_sum">


        <div className="x_meta_anchorlink">

          <div className="x_meta_hover" onClick={() => handleClick(typeRef)} />

          <div className="x_meta_title"
            style={{ color: info["color"] }}
          >

            <div className="x_meta_icon">
              {info['emoji']}
            </div>
            <div className="x_meta_title_txt">
              {info['title']}
            </div>
            <div className="x_meta_title_nums0">
              {Boolean(getMetadata(context, videoId, typeRef).length) && <div className="x_meta_title_num">
                {getMetadata(context, videoId, typeRef).length}
              </div>}
            </div>
            {/* <div className="x_meta_title_num x_meta_title_num--comments">
              <div className="x_meta_comment_icon">
                <div>comment</div>
              </div>
              <div>3</div>
            </div> */}
          </div>

        </div>

        {view === 'summary' && <div className="x_meta_menu">
          <div className="x_button_icon">
            <div>more_vert</div>
          </div>
        </div>}


        {view === 'edit' && <div className="x_meta_actions">
          {/* <UIbutton flat sm
            disabled={typeRef === HIGHTLIGHTS_ID ? true : false}
            onClick={
            () => {
            }
          } >Hide</UIbutton> */}

          <UItoggle
            active={true}
          />

        </div>}


        {view === 'add' && <div className="x_meta_actions">
          {/* <UIbutton flat sm onClick={
            () => {
              // history.push("/createaccount");
              // props.navigation.navigate("CreateAccount")
            }
          } >Add</UIbutton> */}

          <UItoggle
            active={false}
          />

        </div>}



      </div>
    </div>
  )
}

